import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";

interface LoadingProps {
	message: string;
}

export const Loading = ({ message }: LoadingProps) => {
	return (
		<Container>
			<Grid container direction="column" justifyContent="center" alignItems="center">
				<Grid size="grow">
					<CircularProgress size={80} color="secondary" />
				</Grid>
				<Grid size="grow" style={{ marginTop: 20, marginBottom: 20 }}>
					<Box>{message}</Box>
				</Grid>
			</Grid>
		</Container>
	);
};
